<template>
  <div class="mc-modal-alert-media__thumbnail-wrapper" @click="$emit('clickThumbnail', mediaKey)">
    <span class="label-camera">
      <i v-if="mediaType === 'video'" class="icon-fill_videorecord" />
      <i v-if="mediaType === 'image'" class="icon-fill_image" />
      {{ $t('trackVideo.camera') }} {{ camera }}
    </span>

    <div
      v-if="
        thumbnailState === 'request-media' ||
        thumbnailState === 'processing' ||
        thumbnailState === 'no-media'
      "
      class="state-center"
    >
      <McButton
        v-if="thumbnailState === 'request-media'"
        :size="'sm'"
        variant="icon-only"
        icon="icon-outline_download"
        class="btn-request"
        :disabled="requestDisabled"
        @click.stop="clickRequestMedia"
      />
      <span v-else-if="thumbnailState === 'processing'" class="connecting-state"></span>
      <template v-else-if="thumbnailState === 'no-media'">
        <i v-if="mediaType === 'image'" class="mc-fa icon-outline_image-broken"></i>
        <i v-if="mediaType === 'video'" class="mc-fa icon-fill_video-off"></i>
      </template>
    </div>

    <div v-else-if="thumbnailState === 'has-media'" class="thumbnail-media-wrapper">
      <div class="gradient-bg"></div>
      <b-spinner v-if="isGeneratingPreview" />
      <img v-else-if="mediaType === 'image'" :src="mediaUrl" />
      <template v-if="mediaType === 'video'">
        <img
          :src="calculatedThumbnailSrc"
          alt="thumbnail-video-media"
          @error="isThumbnailVideoExist = false"
        />
        <i v-if="!isPlaying" class="icon-fill_play" />
      </template>
    </div>

    <span v-if="isSelected" class="label-selected">
      <i class="icon-fill_checkmark" />
    </span>
  </div>
</template>
<script>
import McButton from '@/components/McButton/index.vue'
import { Helper } from '@/mixin/helper'

export default {
  name: 'ThumbnailMedia',
  components: { McButton },
  mixins: [Helper],
  props: {
    channel: {
      type: Number,
      required: true,
    },
    camera: {
      type: Number,
      required: true,
    },
    mediaType: {
      type: String, // video | image
      required: true,
    },
    thumbnailState: {
      type: String, // request-media | processing | 'has-media'
      required: true,
    },
    mediaUrl: {
      type: String,
      required: false,
      default: '',
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    isPlaying: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGeneratingPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
    mediaKey: {
      type: String,
      required: true,
    },
    requestDisabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isThumbnailVideoExist: true,
    }
  },
  computed: {
    thumbnailSrc() {
      if (this.mediaType === 'image') return null
      return this.getThumbnailVideoUrl(this.mediaUrl)
    },
    fallbackThumbnailUrl() {
      return require('@/assets/images/thumbnailvideo-media.png')
    },
    calculatedThumbnailSrc() {
      if (this.mediaType === 'image') return null
      return this.isThumbnailVideoExist ? this.thumbnailSrc : this.fallbackThumbnailUrl
    },
  },
  methods: {
    clickRequestMedia() {
      this.$emit('clickRequestMedia', this.mediaKey)
    },
  },
}
</script>
